module.exports = __webpack_public_path__ + "static/media/header3.9ac3ed19.gif";